import { useQuery } from '@tanstack/react-query';

import { logisticsApi } from 'api/logistics';

export const crossDockPurchaseOrderAdditionalFeeTypesQueryKeys = {
    all: ['crossDockPurchaseOrders', 'additionalFeeChargeTypes'],
};

/**
 * @param {{ enabled?: boolean }} [options]
 */
export function useCrossDockPurchaseOrderAdditionalFeeTypes(options = {}) {
    const enabled = options.enabled !== false;

    return useQuery({
        queryKey: crossDockPurchaseOrderAdditionalFeeTypesQueryKeys.all,
        enabled,
        queryFn: async () => {
            const response = await logisticsApi.listCrossDockPurchaseOrderAdditionalFeeTypes();
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch additional fee charge types');
            }
            return response.data?.chargeTypes ?? [];
        },
        staleTime: 30 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
    });
}
